export const NO_DATA_MESSAGE = {
    SHIFTS_TO_REVIEW: 'No shifts to review (next 24 hours)',
    RECENTLY_RELEASED_SHIFTS: 'No recent releases to review (previous 12 hours)',
    RECENTLY_ACCEPTED_SHIFTS: 'No recent accepts to review (previous 12 hours)',
    RECENTLY_BLOCKBOOKING_SHIFTS: 'No recent Block Bookings to review'
};
